import React from 'react'

export default function ArrowRightSVG({width,height}) {
    return (
        <svg width={width} height={height} viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.61328 2.71802L9.39537 5.5001L6.61328 8.28218" stroke="#F2F2F2" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M1.60449 5.5H9.31824" stroke="#F2F2F2" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}
